import Organization from "./Organization";
import {AiExtractorPrompt, AiExtractorProviderConnection, AiExtractorType, AiExtractorWebSearchMode, AnthropicReasoningEffort, ExternalWebSearchBackend, GrokReasoningEffort, OpenAiReasoningEffort, OpenAiServiceTier} from "./AiExtractor";
import {ResourceOwnerType} from "./ResourceOwnerType";

class AiReportSummarizer {
    constructor(
        public id?: string,
        public createdAt?: Date,
        public name?: string,
        public description?: string,
        public type?: AiExtractorType,
        public model?: string,
        public openAiServiceTier?: OpenAiServiceTier,
        public openAiReasoningEffort?: OpenAiReasoningEffort,
        public anthropicReasoningEffort?: AnthropicReasoningEffort,
        public grokReasoningEffort?: GrokReasoningEffort,
        public webSearchMode?: AiExtractorWebSearchMode,
        public externalWebSearchBackend?: ExternalWebSearchBackend,
        public systemPrompt?: AiExtractorPrompt,
        public supplementaryPrompt?: AiExtractorPrompt,
        public aiProviderConnection?: AiExtractorProviderConnection,
        public aiProviderConnectionId?: string,
        public owner?: ResourceOwnerType,
        public organization?: Organization,
        public aiProviderCommunicationLoggingEnabled?: boolean,
        public defaultSummarizer?: boolean,
        public inUse?: boolean
    ) {
    }

    public static fromPOJO(data: any) {
        if (!data) return null;

        const entity = new AiReportSummarizer();

        entity.id = data.id;
        entity.createdAt = data.createdAt ? new Date(data.createdAt) : undefined;
        entity.name = data.name;
        entity.description = data.description;
        entity.type = data.type;
        entity.model = data.model;
        entity.openAiServiceTier = data.openAiServiceTier;
        entity.openAiReasoningEffort = data.openAiReasoningEffort;
        entity.anthropicReasoningEffort = data.anthropicReasoningEffort;
        entity.grokReasoningEffort = data.grokReasoningEffort;
        entity.webSearchMode = data.webSearchMode;
        entity.externalWebSearchBackend = data.externalWebSearchBackend;
        entity.systemPrompt = data.systemPrompt;
        entity.supplementaryPrompt = data.supplementaryPrompt;
        entity.aiProviderConnection = data.aiProviderConnection;
        entity.aiProviderConnectionId = data.aiProviderConnection?.id;
        entity.owner = data.owner;
        entity.organization = data.organization ? Organization.fromPOJO(data.organization) : undefined;
        entity.aiProviderCommunicationLoggingEnabled = data.aiProviderCommunicationLoggingEnabled;
        entity.defaultSummarizer = data.defaultSummarizer;
        entity.inUse = data.inUse;

        return entity;
    }
}

export default AiReportSummarizer;
